export default "/images/vendor/flag-icons/flags/1x1/vc.svg?7ad1635f6a2e05857a9f1f07111432b9";